<template>
    <vueper-slides
        ref="slider"
        class="slider no-shadow"
        :arrows="arrows"
        :arrows-outside="arrowsOutside"
        :bullets="bullets"
        :bullets-outside="bulletsOutside"
        :transition-speed="200"
        :infinite="infinite"
        :gap="50"
        :touchable="is_touch_device"
        :fixed-height="height"
    >
        <template v-slot:arrow-left>
            <vx-action-icon
                v-show="hasPrevious"
                size="12"
                icon="ChevronLeftIcon"
                hover-color="primary"
                style="transform: scaleY(1.2)"
            ></vx-action-icon>
        </template>

        <template v-slot:arrow-right>
            <vx-action-icon
                v-show="hasNext"
                size="12"
                icon="ChevronRightIcon"
                hover-color="primary"
                style="transform: scaleY(1.2)"
            ></vx-action-icon>
        </template>

        <vueper-slide v-if="!data.any() && $slots['empty']" class="overflow-visible">
            <template slot="content">
                <slot name="empty"></slot>
            </template>
        </vueper-slide>

        <vueper-slide v-for="(item, index) in data" :key="index" class="overflow-visible">
            <template slot="content">
                <slot name="content" :item="item"></slot>
            </template>
        </vueper-slide>

        <template v-slot:bullets="{ bulletIndexes, goToSlide, previous, next, currentSlide }">
            <button
                v-for="(slideIndex, i) in bulletIndexes"
                :key="i"
                class="m-2 content-button"
                role="tab"
                :aria-label="`Slide ${i + 1}`"
                @click="goToSlide(slideIndex)"
                @keyup.left="() => !hasPrevious || previous()"
                @keyup.right="() => !hasNext || next()"
            >
                <vx-action-icon
                    active-icon="CheckCircleIcon"
                    icon="CircleIcon"
                    :active="currentSlide === slideIndex"
                    active-color="primary"
                    :size="4"
                >
                </vx-action-icon>
            </button>
        </template>
    </vueper-slides>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
    name: 'vx-carousel',
    components: {
        VueperSlides,
        VueperSlide
    },
    props: {
        data: {
            type: Array,
            default: () => []
        },
        infinite: {
            type: Boolean,
            default: false
        },
        arrows: {
            type: Boolean,
            default: true
        },
        arrowsOutside: {
            type: Boolean,
            default: false
        },
        bullets: {
            type: Boolean,
            default: true
        },
        bulletsOutside: {
            type: Boolean,
            default: false
        },
        height: {
            type: [String, Number],
            default: '300px'
        }
    },
    computed: {
        currentSlide() {
            return this.$refs.slider.slides.current
        },
        hasNext() {
            if (!this.infinite) {
                return !!this.$refs.slider.slidesAfterCurrent
            }
            return true
        },
        hasPrevious() {
            if (!this.infinite) {
                return !!this.currentSlide
            }
            return true
        },
        is_touch_device() {
            var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
            var mq = function (query) {
                return window.matchMedia(query).matches
            }

            if ('ontouchstart' in window || window.DocumentTouch) {
                return true
            }

            // include the 'heartz' as a way to have a non matching MQ to help terminate the join
            // https://git.io/vznFH
            var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
            return mq(query)
        }
    },
    methods: {
        goTo(index) {
            if (index != null && this.data[index] != null) {
                this.$refs.slider.goToSlide(index)
            }
        }
    }
}
</script>

<style scoped>
.show-bullet-numbers ::v-deep .vueperslides__bullet span {
    display: block;
    color: #fff;
    font-size: 10px;
    opacity: 0.8;
}
.content-button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
}
.slider ::v-deep .ex--center-mode {
    width: 600px;
    max-width: 100%;
    margin: auto;
}
</style>
